export default __webpack_public_path__ + "static/media/2.82c086b6.jpg";